import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import loginImg from "../../assets/LoginImg.png";
import UpkeepLogo from "../../assets/upkeep-logo.png";
import LoginLogo from "../../assets/LoginLogo.png";
import LineLogo from "../../assets/LineLogo.png";
import ForgotPass from "./forgotPass";
import { adminLogin, createAdmin } from "../../API/adminAuth";
import { toast, ToastContainer } from "react-toastify";

const CreateAdmin = () => {
  const [state, setState] = useState(false);
  const [credentials, setCredentials] = useState({
    name: "",
    email: "",
    password: "",
    cPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  return (
    <div>
      {state && (
        <ForgotPass
          onClickHandler={() => {
            setState(false);
          }}
        />
      )}

      <div className="flex mt-0 mb-0 flex-col lg:grid grid-cols-2">
        <div>
          <body className="scale-75">
            <div className="hidden lg:flex">
              <img
                className="scale-105 left-1/2 -translate-x-1/4 -translate-y-1/5 md:object-contain md:relative"
                src={loginImg}
                alt=""
              />
            </div>
          </body>
        </div>

        <div className="flex flex-col mt-2 md:w-5/6 gap-3 md:pl-40 md:my-28">
          <div className="flex flex-row">
            <img className="scale-75 pr-1 md:pl-1" src={UpkeepLogo} alt="" />
            <h1 className="font-bold text-xl pt-2">Upkeep</h1>
          </div>
          <div className="items-center justify-start">
            <img className="float-left scale-75 pr-4" src={LoginLogo} alt="" />
            <h1 className="text-2xl font-bold pt-1">Create Account</h1>
          </div>
          <div>
            <p className="text-sm text-[#5F5F5F] w-3/4 ml-2 md:ml-2">
              Create Admin account to manage employees information.
            </p>
          </div>
          <div>
            <img src={LineLogo} alt="" />
          </div>
          <div className="flex flex-col w-3/4 ml-4 md:w-full">
            <label className="text-[#5F5F5F] mb-2">Name</label>
            <input
              className="text-slate-500 h-9 w-11/12 p-2 border rounded-lg hover:border-[#3C69DF]"
              type="text"
              placeholder="Enter your name"
              value={credentials?.name}
              onChange={(e) =>
                setCredentials({ ...credentials, name: e.target.value })
              }
            />
          </div>
          <div className="flex flex-col w-3/4 ml-4 md:w-full">
            <label className="text-[#5F5F5F] mb-2">Email</label>
            <input
              className="text-slate-500 h-9 w-11/12 p-2 border rounded-lg hover:border-[#3C69DF]"
              type="email"
              placeholder="Ex: abc@accubits.com"
              value={credentials?.email}
              onChange={(e) =>
                setCredentials({ ...credentials, email: e.target.value })
              }
            />
          </div>
          <div className="flex flex-col w-3/4 ml-4 md:w-full">
            <label className="text-[#5F5F5F] -mb-4">Password</label>
            <br />
            <input
              className="text-slate-500 w-11/12 h-9 p-2 border rounded-lg hover:border-[#3C69DF]"
              type="password"
              placeholder="Enter your password"
              value={credentials?.password}
              onChange={(e) =>
                setCredentials({ ...credentials, password: e.target.value })
              }
            />
          </div>
          <div className="flex flex-col w-3/4 ml-4 md:w-full">
            <label className="text-[#5F5F5F] -mb-4">Confirm Password</label>
            <br />
            <input
              className="text-slate-500 w-11/12 h-9 p-2 border rounded-lg hover:border-[#3C69DF]"
              type="password"
              placeholder="Re-enter your password"
              value={credentials?.cPassword}
              onChange={(e) =>
                setCredentials({ ...credentials, cPassword: e.target.value })
              }
            />
          </div>
          <div className="flex flex-col w-3/4 ml-4 md:w-full mt-4">
            <button
              className="w-11/12 h-12 border rounded-lg bg-[#3C69DF] hover:bg-[#284ba3] text-white text-bold"
              onClick={() => {
                if (credentials?.cPassword !== credentials?.password) {
                  toast.error("Password Mismatched!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                    hideProgressBar: true,
                  });
                  return;
                }
                setLoading(true);
                createAdmin(credentials)
                  .then(function (response) {
                    console.log(response);
                    setLoading(false);
                    toast.info(response?.data?.msg, {
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 5000,
                    });
                    navigate("/UserManagement");
                  })
                  .catch(function (error) {
                    setLoading(false);
                    toast.error("Something went wrong!", {
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 1500,
                      hideProgressBar: true,
                    });
                    console.log(error);
                  });
              }}
            >
              {loading ? (
                <svg
                  class="inline mr-2 w-8 h-8  animate-spin text-white fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              ) : (
                "Sign Up"
              )}
            </button>
          </div>
          <div className="flex  mt-0 justify-center">
            <a
              className="text-[#3B69DF] font-semibold cursor-pointer underline "
              onClick={() => {
                navigate("/AdminLogin");
              }}
            >
              Login
            </a>
          </div>
          <div className="flex flex-col w-full ml-4 md:w-full">
            <p className="text-xs text-gray-400"></p>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default CreateAdmin;
